module.exports = __webpack_public_path__ + "img/router.64133659.png";